module.exports = {
    "metadata": {
        "name": "Cloudomation Docs",
        "short_name": "Cloudomation Docs",
        "description": "Cloudomation Documentation",
        "language": "en",
        "url": "https://docs.cloudomation.com/",
        "pathPrefix": "/",
        "gaTrackingId": null,
        "siteImage": null,
        "favicon": "/assets/favicon.png",
        "themeColor": "#00418C"
    },
    "header": {
        "logo": "/assets/logo.svg",
        "logoLink": "/",
        "helpUrl": "",
        "links": [],
        "enabled": true
    },
    "sidebar": {
        "enabled": true,
        "ignoreIndex": true,
        "forcedNavOrder": [],
        "expanded": [],
        "groups": [
            {
                "order": 1,
                "path": "/getting-started",
                "title": "Getting Started",
                "icon": "/assets/fontawesome/rocket-solid.svg"
            },
            {
                "order": 2,
                "path": "/reference",
                "title": "Reference",
                "icon": "/assets/fontawesome/code-solid.svg"
            },
            {
                "order": 3,
                "path": "/knowledge-base",
                "title": "Knowledge Base",
                "icon": "/assets/fontawesome/book-open-solid.svg"
            },
            {
                "order": 4,
                "path": "/examples",
                "title": "Examples",
                "icon": "/assets/fontawesome/play-circle-solid.svg"
            }
        ],
        "links": [
            {
                "text": "Missing something?  Let us know.\n",
                "link": "/url"
            }
        ],
        "poweredBy": {}
    },
    "pwa": {
        "manifest": {
            "name": "Cloudomation Docs",
            "short_name": "Cloudomation Docs",
            "start_url": "/",
            "background_color": "#00418C",
            "theme_color": "#00418C",
            "display": "minimal-ui",
            "crossOrigin": "anonymous",
            "icon": "static/assets/logo.svg",
            "description": "Cloudomation Documentation",
            "cache_busting_mode": "none",
            "include_favicon": false,
            "lang": "en"
        },
        "enabled": true
    },
    "social": {
        "facebook": "https://www.facebook.com/Cloudomationplatform",
        "github": "",
        "gitlab": "",
        "instagram": "",
        "linkedin": "https://at.linkedin.com/company/starflows",
        "mail": "",
        "gmail": "",
        "slack": "",
        "twich": "",
        "twitter": "",
        "youtube": ""
    },
    "features": {
        "editOnRepo": {
            "editable": false,
            "location": "https://github.com/starflows/documentation",
            "type": "gitlab"
        },
        "search": {
            "enabled": true,
            "indexName": "docs",
            "excerptSize": 20000,
            "engine": "localsearch",
            "placeholder": "Search",
            "startComponent": "icon",
            "debounceTime": 380,
            "snippetLength": 23,
            "hitsPerPage": 10,
            "showStats": true,
            "localSearchEngine": {
                "preset": "match"
            },
            "pagination": {
                "enabled": true,
                "totalPages": 10,
                "showNext": true,
                "showPrevious": true
            }
        },
        "toc": {
            "show": true,
            "depth": 3
        },
        "previousNext": {
            "enabled": true,
            "arrowKeyNavigation": true
        },
        "scrollTop": true,
        "showMetadata": false,
        "propagateNetlifyEnv": true,
        "pageProgress": {
            "enabled": false,
            "excludePaths": [
                "/"
            ],
            "height": 3,
            "prependToBody": false,
            "color": "#A05EB5"
        },
        "mermaid": {
            "language": "mermaid",
            "theme": "dark",
            "options": {},
            "width": 300,
            "height": 300
        },
        "rss": {
            "enabled": false,
            "showIcon": true,
            "title": "My RSS feed",
            "copyright": "",
            "webMaster": "M",
            "managingEditor": "",
            "categories": [
                "GatsbyJS",
                "Docs"
            ],
            "ttl": "60",
            "matchRegex": "^/",
            "outputPath": "/rss.xml",
            "generator": "gidocs"
        },
        "darkMode": {
            "enabled": false,
            "default": false
        },
        "publishDraft": false,
        "fullScreenMode": {
            "enabled": false,
            "hideHeader": true,
            "hideToc": true,
            "hideSidebar": true
        }
    },
    "search": {
        "enabled": true,
        "startComponent": "icon",
        "pagination": {
            "enabled": true
        }
    }
};